function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 1A22.928 22.928 0 007.737 7.737 22.928 22.928 0 001 24c0 5.445 3.582 13.89 7.934 21.868 3.006 5.512 6.398 10.802 9.308 14.754C20.898 64.23 23.062 67 24 67c.939 0 3.102-2.771 5.758-6.378 2.91-3.952 6.302-9.242 9.308-14.754C43.418 37.89 47 29.445 47 24a22.928 22.928 0 00-6.737-16.263A22.928 22.928 0 0024 1z",
  stroke: "#FFF",
  strokeWidth: 2,
  fill: "currentColor",
  fillRule: "evenodd",
  strokeOpacity: 0.3
});

function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 58,
    height: 76,
    viewBox: "-4 0 58 76",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMapPin;